import { XMark } from '@raydiant/raydial/components/Icons';
import { useEffect, useState } from 'react';
import analytics from '../../clients/analyticsClient';

const SCHEDULING_HELP_URL =
  'https://help.displai.ai/digital-signage/5imknKqrcgd6fwhKk5jfp3/scheduling-content/7k5umZHN4tPG3bYXECyAxF';

const HIDE_AFTER = new Date('2026-05-18T23:59:59-07:00');

const SchedulingBanner = () => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const now = new Date();
    const timeUntilHide = HIDE_AFTER.getTime() - now.getTime();

    if (timeUntilHide <= 0) {
      setIsOpen(false);
      return;
    }

    const timeout = setTimeout(() => setIsOpen(false), timeUntilHide);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    analytics.trackSchedulingBannerViewed();
  }, []);

  if (!isOpen) return null;

  return (
    <div className="bg-blue-100 p-2 flex items-center justify-center relative">
      <span className="text-lg font-semibold text-black px-2">
        New: Smarter Scheduling is here
      </span>
      <a
        href={SCHEDULING_HELP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-white rounded-3xl flex justify-center items-center h-6"
        onClick={() => analytics.trackSchedulingBannerClicked()}
      >
        <span className="text-sm font-bold text-black px-3 py-1">
          Learn more
        </span>
      </a>
      <button
        className="absolute right-2.5"
        aria-label="Close scheduling banner"
        onClick={() => {
          analytics.trackSchedulingBannerDismissed();
          setIsOpen(false);
        }}
      >
        <XMark className="text-black" />
      </button>
    </div>
  );
};

export default SchedulingBanner;
